import { put, takeEvery } from "redux-saga/effects";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as actionTypes from "./constants";
import { appConfig } from "../../config";
import { push } from "connected-react-router";
import jsPDF from "jspdf";
import "jspdf-autotable";
var dateFormat = require("dateformat");
var btoa = require("Base64").btoa;

function* fetchinvoice(params) {
  let page = (params.params && params.params.page) || 1;
  let search = (params.params && params.params.search) || "";
  let filter = (params.params && params.params.filter) || "";
  let secfilter = (params.params && params.params.secfilter) || "";
  let dateFilter = (params.params && params.params.dateFilter) || "";

  let filterParam = "";
  if (filter) {
    filterParam = `&type=${filter}`;
  }

  let secfilterParam = "";
  if (secfilter) {
    secfilterParam = `&status=${secfilter}`;
  }

  let user = JSON.parse(localStorage.getItem("user"));
  let id = user.orgId;
  let recieverid = user.orgId;
  let url = "";
  let recieverParam = "";

  if (
    user.role === "shipper-enterprise" ||
    user.role === "shipper-individual" ||
    user.role === "shprAccount" ||
    user.role === "shprSupport" ||
    user.role === "warehouse"
  ) {
    url = `&recieverOrgId=${id}`;
  }
  if (
    user.role === "runner" ||
    user.role === "runnerTrip" ||
    user.role === "runnerSupport" ||
    user.role === "runnerAccount"
  ) {
    recieverParam = `&creatorOrgId=${user.orgId}`;
    url = `&creatorOrgId=${user.orgId}`;
  }

  if (user.role === "warehouse") {
    recieverParam = `&creatorOrgId=${user.orgId}`;
    url = `&creatorOrgId=${user.orgId}`;
  }

  try {
    const token = localStorage.getItem("token");
    const res = yield fetch(
      `${appConfig.ip}/invoice?limit=10&ser=${search}&page=${page}${url}${filterParam}${secfilterParam}${dateFilter}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield put({
        type: actionTypes.FETCH_INVOICE_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: actionTypes.FETCH_INVOICE_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* pdfFullData(value) {
  const token = localStorage.getItem("token");
  let user = JSON.parse(localStorage.getItem("user"));
  console.log("++++++++++++value@@@@@@@@@", value);

  const no = value.value.no;
  let name = value.value.reciever.name;
  let orgName = value.value.reciever.orgName;
  let mobileNo = value.value.reciever.mobileNo;
  let email = value.value.reciever.email;
  let subscriptnNo = "";
  let planname = "";
  let loadRefNo = "";
  let noOfLoads = "";
  let validity = "";
  let kms = "";
  let totalpurchaseunit = "";
  let minSellableUnit = "";
  let noMinSellableUnit = "";
  let warehousevalidity = "";

  const Date = dateFormat(value.value.createdAt, "mediumDate");

  try {
    const res = yield fetch(`${appConfig.ip}/invoice/` + value.value.id, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      let id = resJSON.creator.orgId;
      console.log("---------resJSON===========", resJSON);
      console.log("---------id===========", id);
      yield put({
        type: actionTypes.FETCH_INVOICECONFIGURATION_ACTION,
      });
      try {
        const res1 = yield fetch(`${appConfig.ip}/invoiceConfig?orgId=${id}`, {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        });
        if (!res1.ok) {
          let errJSON = {};
          try {
            errJSON = yield res1.json();
          } catch {}
          throw Object.assign(res1, errJSON);
        } else {
          let resJSON1 = yield res1.json();
          console.log("---------resJSON1===========", resJSON1);
          let terms = "";
          if (resJSON1.count !== 0) {
            terms = resJSON1.rows[0].terms;
          }
          // var myImage = resJSON1.rows[0].imgUrl;
          console.log("---------myImage===========", terms);
          let createdAt = "";
          let createdate = "";
          if (resJSON.loadId == null) {
            createdate = dateFormat(
              resJSON != null && resJSON.createdAt,
              "mediumDate"
            );
          } else {
            createdAt = dateFormat(
              resJSON.loadId != null && resJSON.loadId.createdAt,
              "mediumDate"
            );
          }
          const doc = new jsPDF();
          let tableColumn = [];
          if (resJSON.loadId == null) {
            tableColumn = [
              "SL NO",
              "SUBSCRIPTION NO",
              "GATE WAY CHARGE",
              "GST",
              "TOTAL AMOUNT",
            ];
          } else {
            tableColumn = [
              "SL NO",
              "LOAD NO",
              "GATE WAY CHARGE",
              "GST",
              "TOTAL AMOUNT",
            ];
          }

          const tableRows = [];
          let reportData = [];
          const ArrayConv = resJSON;

          if (resJSON.loadId == null) {
            reportData = [
              1,
              ArrayConv.subscriptnNo,
              ArrayConv.gatewayCharge ? ArrayConv.gatewayCharge.toFixed(2) : 0,
              ArrayConv.gst ? ArrayConv.gst.toFixed(2) : 0,
              ArrayConv.currency.iso4217Code + ArrayConv.amount,
            ];
          } else {
            reportData = [
              1,
              ArrayConv.loadId.loadRefNo,
              ArrayConv.gatewayCharge ? ArrayConv.gatewayCharge.toFixed(2) : 0,
              ArrayConv.gst ? ArrayConv.gst.toFixed(2) : 0,
              ArrayConv.currency.iso4217Code + ArrayConv.amount,
            ];
          }

          tableRows.push(reportData);
          doc.autoTable(tableColumn, tableRows, {
            theme: "plain",
            styles: {
              halign: "center",
              lineWidth: 0.2,
              lineColor: "black",
            },
            headerStyles: {
              fillColor: "white",
              halign: "center",
              textColor: "black",
            },
            margin: {
              top: 65,
            },
          });
          // { align: "center" }

          let grantTotal =
            resJSON.amount + resJSON.gatewayCharge + resJSON.gst
              ? (resJSON.amount + resJSON.gatewayCharge + resJSON.gst).toFixed(
                  2
                )
              : resJSON.amount.toFixed(2);
          let currency = resJSON.currency.iso4217Code;
          if (value.value.loadRefNo == null) {
            if (resJSON.type == "warehouse") {
              subscriptnNo = value.value.subscriptnNo;
              planname = resJSON.warehsSubscrptnId.warehsSubPlan.name;
              totalpurchaseunit =
                resJSON.warehsSubscrptnId.warehsSubPlan.minSellableUnit *
                resJSON.warehsSubscrptnId.warehsSubPlan.noMinSellableUnit;
              minSellableUnit =
                resJSON.warehsSubscrptnId.warehsSubPlan.minSellableUnit;
              noMinSellableUnit =
                resJSON.warehsSubscrptnId.warehsSubPlan.noMinSellableUnit;
              warehousevalidity =
                resJSON.warehsSubscrptnId.warehsSubPlan.validity + " Days";
            } else {
              subscriptnNo = value.value.subscriptnNo;
              planname = resJSON.subscriptnPlanId.name;
              noOfLoads = resJSON.subscriptnPlanId.noOfLoads;
              kms = resJSON.subscriptnPlanId.kms + " Km";
              validity = resJSON.subscriptnPlanId.validity + " Days";
            }
          } else {
            loadRefNo = value.value.loadRefNo;
          }
          if (value.value.subscriptnPlanId) {
            subscriptnNo = value.value.subscriptnNo;
            planname = resJSON.subscriptnPlanId.name;
            noOfLoads = resJSON.subscriptnPlanId.noOfLoads;
            kms = resJSON.subscriptnPlanId.kms + " Km";
            validity = resJSON.subscriptnPlanId.validity + " Days";
          }

          let creatorname = value.value.creator.name;
          let creatororgName = value.value.creator.orgName;
          let creatormobileNo = value.value.creator.mobileNo;
          let creatoremail = value.value.creator.email;
          let creatorgstin = value.value.creator.gstin;

          let paymenttype = resJSON.payment
            ? resJSON.payment.paymentType.name
            : "Nil";
            let transactionnumber = resJSON.payment
            ? resJSON.payment.txnRefNo
            : "Nil";
          doc.setFontSize(11);
          doc.text(`${name}`, 14, 35, { textTransform: "capitalize" });
          doc.text(`${orgName}`, 14, 40);
          doc.text(`${mobileNo}`, 14, 45);
          doc.text(`${email}`, 14, 50);
          doc.text(`Invoice No : ${no}`, 140, 40);
          doc.text(`Invoice Date : ${Date}`, 140, 45);
          if (value.value.type == "load") {
            doc.text(`Load No : ${loadRefNo}`, 140, 50);
          }
          doc.text(`GRAND TOTAL : ${currency} ${grantTotal}`, 135, 90);
          if (resJSON.payment) {
            doc.setFontSize(11);
            doc.text(`Payment Type : ${paymenttype}`, 135, 100);
            if (resJSON.payment.txnRefNo) {
              doc.setFontSize(11);
              doc.text(`Transaction Number : ${transactionnumber}`, 135, 105);
            }
          } else {
          }

          if (value.value.loadRefNo == null) {
            if (resJSON.type == "warehouse") {
              doc.setFontSize(11);
              doc.text(`Subscription No : ${subscriptnNo}`, 14, 100);
              doc.text(`Plan Name : ${planname}`, 14, 105);
              doc.text(
                `Total Purchase Unit : ${totalpurchaseunit} (${minSellableUnit} * ${noMinSellableUnit})`,
                14,
                110
              );
              // doc.text(`Min Sellable Unit : ${minSellableUnit}`, 14, 110);
              // doc.text(`No Min Sellable Unit : ${noMinSellableUnit}`, 14, 115);
              doc.text(`Validity : ${warehousevalidity}`, 14, 115);
            } else {
              doc.setFontSize(11);
              doc.text(`Subscription No : ${subscriptnNo}`, 14, 100);
              doc.text(`Plan Name : ${planname}`, 14, 105);
              doc.text(`No Of Loads : ${noOfLoads}`, 14, 110);
              doc.text(`Distance : ${kms}`, 14, 115);
              doc.text(`Validity : ${validity}`, 14, 120);
            }
          } else {
            // doc.setFontSize(11);
            // doc.text(`Load No : ${loadRefNo}`, 14, 100);
          }
          if (value.value.subscriptnPlanId) {
            doc.setFontSize(11);
            doc.text(`Subscription No : ${subscriptnNo}`, 14, 100);
            doc.text(`Plan Name : ${planname}`, 14, 105);
            doc.text(`No Of Loads : ${noOfLoads}`, 14, 110);
            doc.text(`Distance : ${kms}`, 14, 115);
            doc.text(`Validity : ${validity}`, 14, 120);
          }

          if (resJSON.loadId == null) {
            if (resJSON.type == "warehouse") {
              doc.setFontSize(11);
              doc.text(`Subscription Date : ${createdate}`, 14, 120);
              if (resJSON1.count !== 0) {
                doc.text(`* ${terms}`, 14, 126, { maxWidth: 180 });
              }
            } else {
              doc.setFontSize(11);
              doc.text(`Subscription Date : ${createdate}`, 14, 125);
              if (resJSON1.count !== 0) {
                doc.text(`* ${terms}`, 14, 131, { maxWidth: 180 });
              }
            }
          } else if (value.value.subscriptnPlanId) {
            doc.setFontSize(11);
            if (resJSON1.count !== 0) {
              doc.text(`* ${terms}`, 14, 131, { maxWidth: 180 });
            }
          } else {
            doc.setFontSize(11);
            if (resJSON1.count !== 0) {
              doc.text(`* ${terms}`, 14, 115, { maxWidth: 180 });
            }
          }
          if (value.value.type == "load") {
            doc.setFontSize(11);
            doc.text("Authorized Signature", 145, 150);
          } else {
            doc.setFontSize(11);
            doc.text("Authorized Signature", 140, 150);
          }
          doc.setFontSize(16);
          doc.text(`Invoice`, 14, 20);
          doc.line(10, 160, 200, 160);
          doc.setFontSize(10);
          doc.text(`THANK YOU FOR YOUR BUSINESS`, 100, 165, {
            align: "center",
          });
          doc.setFontSize(11);
          doc.text(`${creatororgName}`, 100, 170, { align: "center" });
          doc.text(`Ph :${creatormobileNo} , Email:${creatoremail}`, 100, 175, {
            align: "center",
          });
          doc.text(`GSTIN : ${creatorgstin}`, 100, 180, { align: "center" });

          doc.save(`${no}.pdf`);

          yield put({
            type: actionTypes.FETCH_INVOICECONFIGURATION_SUCCESS_ACTION,
            payload: resJSON1,
          });
        }
      } catch (err) {
        yield put({
          type: actionTypes.FETCH_INVOICECONFIGURATION_FAIL_ACTION,
          error: err,
        });
      }

      yield put({
        type: actionTypes.PDF_REPORT_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.PDF_REPORT_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

export function* invoiceMapActionWatcher() {
  yield takeEvery(actionTypes.FETCH_INVOICE_ACTION, fetchinvoice);
  yield takeEvery(actionTypes.PDF_REPORT_INIT_ACTION, pdfFullData);
}
